/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleDown} from '@fortawesome/pro-light-svg-icons';

const style = {
  fontSize: '1.8em',
  verticalAlign: '-20%',
};

const DownIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faAngleDown} style={style} {...props} />
);

export default DownIcon;
